import { useParams, Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { getRequestByToken } from '../services/api'
import './ThankYouPage.css'

function ThankYouPage() {
  const { token } = useParams() // Access token, not requestId
  const [requestData, setRequestData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function loadRequestData() {
      try {
        const response = await getRequestByToken(token)
        setRequestData(response.data)
        setLoading(false)
      } catch (error) {
        console.error('Failed to load request data:', error)
        setRequestData({ requestId: 'Unknown' })
        setLoading(false)
      }
    }
    loadRequestData()
  }, [token])

  if (loading) return <div>Loading...</div>

  const requestId = requestData?.requestId || 'Unknown'

  return (
    <div className="thank-you-page">
      <div className="thank-you-content">
        <div className="success-icon">✅</div>
        <h1 className="success-title">Request Submitted Successfully!</h1>
        <p className="success-message">
          Thank you for choosing StartupHive! We're excited to help your startup succeed in Japan.
        </p>

        <div className="request-details">
          <div className="detail-row">
            <span className="detail-label">Request ID:</span>
            <span className="detail-value">{requestId}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Submitted:</span>
            <span className="detail-value">{new Date().toLocaleString()}</span>
          </div>
        </div>

        <div className="next-steps-info">
          <h3>What Happens Next?</h3>
          <ul>
            <li>We'll review your request within 1 business day</li>
            <li>You'll receive a detailed proposal and timeline</li>
            <li>Contract and deposit invoice (¥10,000) will be sent to your email</li>
            <li>Project begins once deposit is received</li>
          </ul>
        </div>

        <div className="action-buttons">
          <Link to={`/edit/${token}`} className="btn-edit">
            ✏️ Edit Request
          </Link>
          <Link to="/" className="btn-home">
            Return to Homepage
          </Link>
        </div>

        <p className="edit-note">
          You can edit your request anytime using the edit link above or from the email we'll send you.
        </p>
      </div>
    </div>
  )
}

export default ThankYouPage
